"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cn } from "../../lib/utils"

export interface GrimoireTab {
  label: React.ReactNode
  value: string
  disabled?: boolean
}

export interface GrimoireTabsProps {
  tabs: GrimoireTab[]
  defaultValue?: string
  value?: string
  onValueChange?: (value: string) => void
  variant?: "pill" | "underline"
  className?: string
}

export function GrimoireTabs({
  tabs,
  defaultValue,
  value,
  onValueChange,
  variant = "pill",
  className,
}: GrimoireTabsProps) {
  return (
    <TabsPrimitive.Root
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
    >
      <TabsPrimitive.List
        className={cn(
          variant === "pill"
            ? "inline-flex gap-1 rounded-full bg-ac-surface-2 p-[6px]"
            : "flex gap-6 border-b-[1.5px] border-border",
          className
        )}
      >
        {tabs.map((tab) => (
          <TabsPrimitive.Trigger
            key={tab.value}
            value={tab.value}
            disabled={tab.disabled}
            className={cn(
              "text-[14px] font-semibold disabled:pointer-events-none disabled:opacity-50",
              variant === "pill"
                ? "rounded-full px-5 py-[10px] text-muted-foreground data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm"
                : "px-[2px] py-3 text-muted-foreground border-b-2 border-transparent data-[state=active]:text-ac-mint-primary data-[state=active]:border-ac-mint-primary"
            )}
            style={{
              transition: `background-color var(--ac-dur-base) var(--ac-ease-out), color var(--ac-dur-base) var(--ac-ease-out), border-color var(--ac-dur-base) var(--ac-ease-out)`,
            }}
          >
            {tab.label}
          </TabsPrimitive.Trigger>
        ))}
      </TabsPrimitive.List>
    </TabsPrimitive.Root>
  )
}
